import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import OnTraccrButton from '../../../common/buttons/OnTraccrButton';
import useToggle from '../../../common/hooks/useToggle';
import WorkflowSimpleMappingConfigureDrawer from '../../FormWorkflows/WorkflowSimpleMappingConfigureDrawer';
import WorkflowConfigureSourceSelector from '../../FormWorkflows/selectors/WorkflowConfigureSourceSelector';

const validDataTypes = new Set([
  'Shifts',
]);

const fieldMap = {
  Shifts: [
    {
      key: 'title',
      text: 'Title',
      type: 'text',
    },
    {
      key: 'dates',
      text: 'Dates',
      type: 'dateRange',
    },
    {
      key: 'description',
      text: 'Description',
      type: 'text',
    },
  ],
};

const titleField = ({
  fieldMappings,
  sourceFieldMap,
  defaultValue,
  onFieldMappingsChange,
}) => {
  const eligibleSourceFields = [];

  const {
    text = [],
  } = sourceFieldMap;

  eligibleSourceFields.push(...text);

  Object.keys(sourceFieldMap).forEach((key) => {
    if (key.includes('dropdown')) {
      eligibleSourceFields.push(...(sourceFieldMap[key] || []));
    }
  });

  return (
    <WorkflowConfigureSourceSelector
      fieldMappings={fieldMappings}
      sourceFieldMap={sourceFieldMap}
      defaultValue={defaultValue}
      onFieldMappingsChange={onFieldMappingsChange}
      targetId="title"
      eligibleSourceFields={eligibleSourceFields}
    />
  );
};

const fieldRenderMap = {
  title: titleField,
};

export default function TableAutofill({
  configProps,
  updateConfig,
  sections,
  id,
  dataType,
}) {
  const filteredSections = useMemo(() => (
    sections?.map((section) => ({
      ...section,
      fields: section?.fields?.filter((field) => field && field.id !== id),
    })) || []
  ), [sections, id]);

  const { toggle, isToggled } = useToggle(false);
  const onFieldMappingsChange = (fieldMappings) => {
    updateConfig({ fieldMappings });
  };

  if (!validDataTypes.has(dataType)) return null;

  return (
    <>
      <OnTraccrButton
        title="Configure Autofill"
        onClick={toggle}
        style={{ marginTop: 10 }}
      />
      <WorkflowSimpleMappingConfigureDrawer
        visible={isToggled}
        onClose={toggle}
        onSubmit={toggle}
        sourceSections={filteredSections}
        fieldMappings={configProps.fieldMappings}
        onFieldMappingsChange={onFieldMappingsChange}
        fields={fieldMap[dataType]}
        fieldRenderMap={fieldRenderMap}
      />
    </>
  );
}

TableAutofill.propTypes = {
  configProps: PropTypes.shape({
    fieldMappings: PropTypes.shape({}),
  }).isRequired,
  updateConfig: PropTypes.func.isRequired,
  sections: PropTypes.arrayOf(PropTypes.shape({
    fields: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    })),
  })).isRequired,
  id: PropTypes.string.isRequired,
  dataType: PropTypes.string.isRequired,
};
